<div class="banner button-banner">
    <div>
        <sc-title type="h2" [content]="config.title"></sc-title>
        <p class="button-banner__text" [innerHTML]="config.subtitle">
        </p>
        <ng-content></ng-content>
        <div class="button-banner__button-container" *ngIf="config.buttonText && config.buttonId">
            <sc-button (onClick)="onClick()" type="secondary" [loading]="loading" [id]="config.buttonId">
                {{config.buttonText}}
            </sc-button>
        </div>
    </div>
    <img [src]="config.mobileImage" [alt]="config.title" class="d-block d-lg-none button-banner__image">
    <img [src]="config.image" [alt]="config.title" class="d-none d-lg-block button-banner__image">
</div>